import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { WithContext as ReactTags } from 'react-tag-input';
import SimplePagination from "./SimplePagination";
import DossierView from "./DossierView";
import { LangContext } from "../LangContext.jsx";
class ReplaceDossier extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            dossierIdView:'',
            total:0,
            page:1,
            step:1,
            prevStep:2,
            showDossiers:true,
            maxRecords: 5,
            dossiers:[],
            dossierData:[],
            confirmationText:'',
            selectAll:false,
            selectedDocuments: [],
            selectedDossier:'',
            isButtonDisabled: true,
            isButtonReplaceDisabled:true
        };
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.handleOpenModalReplace = this.handleOpenModalReplace.bind(this);
    }
    componentDidMount() {
        const lang = this.context.lang; 
        const confirmationText = lang.get('messages.todos_los_documentos_que_no_seleccionaste_seran_eliminados_estas_seguro_que_deseas_continuar');

        this.setState({ confirmationText });
    }
    changeStep(step){
        if(step == undefined){
            this.setState({step: this.state.prevStep})
        }else{
            if(step == 1){
                this.setState({allDocumentsSelected: false})
                this.setState({selectedDocuments: []})
            }
            this.setState({step: step})
        }

    }
    nextStep(){
        let nextStep = this.state.step++;
        this.setState({prevStep: 2})
        this.setState({step: 3})
    }
    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.handleOpenModalReplace();
        });
    }

    getDossierInfo = (id)=>{
        this.setState({showDossiers: false})
        this.setState({dossierIdView: id})
    }
    backDossiers = ()=>{
        this.setState({showDossiers: true})
    }
    replaceDossier = ()=>{
        const lang = this.context.lang; 
        let data = {
            'documents':this.state.selectedDocuments,
            'person_provider_id':this.props.person_provider_id,
            'dossier_id':this.props.dossier_id,
            'replace_id':this.state.selectedDossier.id
        };
        axios.post('/api/dossiers_to_replace/replace',data).then(res=>{
            swal.fire({
                text: lang.get('messages.el_expediente') + ' “'+this.props.dossier_name+ '”' + lang.get('messages.ha_sido_sustituido_exitosamente_por') + '“'+this.state.selectedDossier.title+'”.',
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                    location.reload();
            });

        })
    } 
    handleDocumentSelect = (id) => {
        const selectedDocuments = [...this.state.selectedDocuments];
        const index = selectedDocuments.indexOf(id);
        if (index !== -1) {
            selectedDocuments.splice(index, 1);
        } else {
            selectedDocuments.push(id);
        }
        this.setState({ selectedDocuments });
        const allDocumentsSelected = this.state.dossierData.every((o) => {
            return o.documents.every((document) => {
                return selectedDocuments.includes(document.id);
            });
        });
        this.setState({ allDocumentsSelected },function(){
            if(this.state.selectedDocuments.length > 0){
                this.setState({isButtonReplaceDisabled:false})
            }else{
                this.setState({isButtonReplaceDisabled:true})
            }
        });

    };
    
    handleSelectAllDocuments = (event) => {
        const selectedDocuments = [];
        if (event.target.checked) {
            this.state.dossierData.forEach((o) => {
                selectedDocuments.push(o.document.id);
            });
        }
        this.setState({
            selectedDocuments,
            allDocumentsSelected: event.target.checked,
        },function(){
            if(this.state.selectedDocuments.length > 0){
                this.setState({isButtonReplaceDisabled:false})
            }else{
                this.setState({isButtonReplaceDisabled:true})
            }
        });
    };

    checkDossierTransaction = ()=>{
        const lang = this.context.lang; 
        axios.post('/api/dossiers_to_replace/transaction',{
            'dossier':this.props.dossier_id,
            'replace':this.state.selectedDossier,
            'person_provider_id':this.props.person_provider_id
        }).then(res=>{
            if(res.data.length == 0){
                this.setState({prevStep: 1})
                this.setState({step: 3})
                this.setState({confirmationText:lang.get('messages.estas_seguro_del_remplazo_del_expediente')})
            }else{
                this.setState({prevStep: 1})
                this.setState(prevState => ({
                    step: 2,
                    dossierData: res.data
                }));
            }
        })
    }

    handleRadioChange = (e, dossier) => {
        this.setState({
            selectedDossier: dossier,
            isButtonDisabled: false
        });
    };

    handleSearchDossiers = async (ev) => { 
        window.blockUI();
        var url = '/api/dossiers_to_replace/';
        const query = new URLSearchParams();
        query.append('search', ev.target.value)
        query.append('invitation_id', this.props.invitation_id)
        query.append('person_provider_id', this.props.person_provider_id)
        const qs = query.toString();
        axios.get('/api/dossiers_to_replace/'+this.props.dossier_id +`?${qs}`).then(res=>{
            window.unblockUI();
            this.setState({dossiers: res.data.data});
            this.setState({total: res.data.total});
        })
    }

    handleOpenModalReplace() { 
        window.blockUI();
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('person_provider_id', this.props.person_provider_id)
        const qs = query.toString();
        axios.get('/api/dossiers_to_replace/'+this.props.dossier_id +`?${qs}`).then(res=>{
            window.unblockUI();
            this.setState({dossiers: res.data.data});
            this.setState({total: res.data.total});
        })
    }

    render() {
        const { lang } = this.context; 
        return (
            <>
            <div className="modal fade" id="replaceDossiers" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content"  >
                        {this.state.step == 1 &&
                        <div className="modal-body px-15 py-10">

                            { this.state.showDossiers == true &&
                            <>
                            <div className="row d-flex justify-content-between">
                                <h5 className="text-dark card-title  font-weight-bold my-1 mr-5">{lang.get('messages.reemplazar_expediente')}  {this.props.dossier_name} </h5>
                                <div className="input-icon">
                                    <input name="search" type="text" onChange={this.handleSearchDossiers} o className="form-control" placeholder={lang.get('messages.buscar_mis_expedientes')}/>
                                    <span><i className="flaticon2-search-1 text-primary icon-md"></i></span>
                                </div>
                            </div>
                            <div className="card card-custom gutter-b my-5">
                                <div className="card-body pt-5">
                                    <h5 className="align-items-start flex-column">
                                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.selecciona_la_plantilla_del_nuevo_expedientes')}</span>
                                    </h5>
                                    <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.expedientes_disponibles')}</span>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                    <th>{lang.get('messages.nombre')}</th>
                                                    <th>{lang.get('messages.relacion')}</th>
                                                    <th>{lang.get('messages.tipo')}</th>
                                                    <th>No. {lang.get('messages.de_documentos')}</th>
                                                    <th></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-dark-50">
                                            {this.state.dossiers.map((o, i) => {
                                            return <tr key={i}>
                                                <td className=" ">
                                                    <input className="mr-5" type="radio" value={o.id} checked={o.id === this.state.selectedDossier.id} onChange={(e) => this.handleRadioChange(e, o)} />
                                                    <i className="flaticon2-open-text-book mr-5" style={{ color: 'inherit' }}></i>
                                                    {o.title}
                                                </td>
                                                <td className=" "> {o.target.name}</td>
                                                <td className=" ">{o.type.title}</td>
                                                <td className=" ">{o.documents.length}</td>
                                                <td>
                                                    <a onClick={(e)=>{ this.getDossierInfo(o.id) }}>
                                                        <button className="btn btn-icon btn-light btn-xs">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </a>
                                                </td>
                                            </tr> })}
                                            { this.state.total > this.state.maxRecords  &&
                                                <SimplePagination
                                                updateCurrentPage={this.updateCurrentPage}
                                                currentPage={this.state.page}
                                                totalFiles={this.state.total}
                                                split={this.state.maxRecords} />
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end gap-1 mt-5">
                                <button className="btn btn-secondary" data-dismiss="modal">{lang.get('messages.cancelar')}</button>
                                <button className="btn btn-primary" onClick={(e) => this.checkDossierTransaction()} disabled={this.state.isButtonDisabled}>{lang.get('messages.continuar')}</button>
                            </div>
                            </>
                            }
                             { this.state.showDossiers == false &&
                            <>
                            <div className="card card-custom gutter-b my-5">
                                <div className="card-body pt-5">
                                <DossierView  dossier_id={this.state.dossierIdView}   />

                                </div>
                            </div>
                            <div className="d-flex justify-content-end gap-1 mt-5">
                                <button className="btn btn-primary" onClick={(e) => this.backDossiers()}  >{lang.get('messages.regresar')}</button>
                            </div>
                            </>
                            }

                        </div>
                        }
                        {this.state.step == 2 &&
                        <div className="modal-body px-15 py-10">
                        <h5 className="text-dark card-title  font-size-h4  font-weight-bold my-1 mr-5">Reemplazar expediente {this.props.dossier_name} {lang.get('messages.por')} {this.state.selectedDossier.title} </h5>

                        <div className="card card-custom gutter-b my-5">
                        <div className="card-body pt-5">

                        <h5 className="align-items-start flex-column">
                            <span className="card-label font-size-h5 text-dark-75">{lang.get('messages.el_expediente_cuenta_con_estos_documentos_ya_cargados_selecciona_los_que_deseas_conservar')}.</span>
                        </h5>

                        <input type="checkbox" className="mr-5" checked={this.state.allDocumentsSelected} onChange={this.handleSelectAllDocuments} />
                        <span className="font-size-sm">{lang.get('messages.seleccionar_todos')}</span>


                        <div className="templates_container">
                                {this.state.dossierData.map((o, i) => {
                                return  <div key={i} className="border-bottom mb-3">
                                            <div className="mb-3">
                                                <input
                                                            type="checkbox"
                                                            checked={this.state.selectedDocuments.includes(o.document.id)}
                                                            onChange={() => this.handleDocumentSelect(o.document.id)}
                                                        /> <span className="font-weight-bolder text-dark-65 ml-5">{o.document.title} -
                                                        {o.document.frequency == 'once' ? ' Único': ' Recurrente' }

                                                        </span>
                                            </div>
                                            <div className="pl-5 ml-5">
                                                    {o.documents.map((document, documentIndex) => (
                                                    <div key={documentIndex} className="mb-5">
                                                        <img   className="mr-5  " src={"/assets/img/" + window.getMimeSVG(document.file.extension)}/>
                                                        <span className="mr-5  text-dark-65  ">{o.document.title}</span>
                                                        <span className="text-muted">{lang.get('messages.'+document.status.name.toLowerCase().replace(/ /g, '_'))}</span>
                                                            <a className="text-left ml-2 text-primary cursor-pointer"
                                                            type="button" data-toggle="collapse"

                                                            data-target={`#collapse${document.file.id}`}
                                                            aria-expanded="false" aria-controls="collapseOne">
                                                            {lang.get('messages.ver_info')}</a>
                                                            <div id={`collapse${document.file.id}`} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                            <div className="d-flex justify-content-between p-5">
                                                                <span>Solicitado {document.requestDate}</span>
                                                                <span>Cargado {document.uploadDate}</span>
                                                                <span>Aprobado {document.approvedDate}</span>
                                                                <span>Historial {document.expiredDate}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    ))
                                                    }
                                                    </div>
                                        </div> })
                                        }
                                    </div>


                            </div>
                        </div>
                        <div className="d-flex justify-content-end gap-1 mt-5">
                                <button className="btn btn-secondary" onClick={(e) => this.changeStep(1)}  >{lang.get('messages.regresar')}</button>
                                <button className="btn btn-primary" onClick={(e) => this.nextStep()}>{lang.get('messages.reemplazar_expediente')}</button>
                            </div>
                    </div>
                        }
                        { (this.state.step == 3   ) &&
                        <div className="modal-body px-15 py-10">
                            <div className="card card-custom gutter-b my-5">
                                <div className="card-body text-center pt-5 extra-padding">
                                    <span className="mt-3 font-weight-bold font-size-lg">
                                        {this.state.confirmationText}
                                    </span>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end gap-1 mt-5">
                            <button className="btn btn-secondary" onClick={(e) => this.changeStep()}  >{lang.get('messages.regresar')}</button>
                            
                                        <button className="btn btn-primary" onClick={(e) => this.replaceDossier()}  >{lang.get('messages.confirmar')}</button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default ReplaceDossier;

if (document.getElementById('ReplaceDossier')) {
    ReactDOM.render(<ReplaceDossier />, document.getElementById('ReplaceDossier'));
}
